import { render } from "./ListSpeakersView.vue?vue&type=template&id=65296ae8"
import script from "./ListSpeakersView.vue?vue&type=script&lang=js"
export * from "./ListSpeakersView.vue?vue&type=script&lang=js"

import "./ListSpeakersView.vue?vue&type=style&index=0&id=65296ae8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__